/**
 * Account Mapping (FSD 2.2.7 "Map Accounts", FIN-F07-V02): each member's local accounts
 * mapped to the group chart, versioned and effective-dated. Reading needs
 * `consol.mapping.read`; saving and suggestions are gated on the action by
 * `consol.mapping.manage`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { CONSOL_PERMISSIONS } from '@/modules/consol/permissions'

export const CONSOL_ACCOUNT_MAP_ROUTES: RouteRecordRaw[] = [
  {
    path: '/consol/account-maps',
    name: 'consol-account-maps',
    component: () => import('@/modules/consol/account-maps/AccountMapsView.vue'),
    meta: { titleKey: 'consol.routeTitles.accountMaps', permission: CONSOL_PERMISSIONS.mappingRead },
  },
]
